import { useState } from 'react';
import { Copy, Check, RefreshCw, ArrowDownToLine, BookmarkPlus } from 'lucide-react';

interface Props {
  response: string;
  onRegenerate: () => void;
  onSaveAsTemplate?: (content: string) => void;
  loading: boolean;
}

export function ResponseCard({ response, onRegenerate, onSaveAsTemplate, loading }: Props) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(response);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const insertIntoReply = () => {
    const item = Office.context?.mailbox?.item;
    if (item && 'body' in item && typeof (item.body as any).setAsync === 'function') {
      (item.body as any).setAsync(response, { coercionType: Office.CoercionType.Text });
    } else if (item && 'displayReplyForm' in item) {
      (item as any).displayReplyForm({
        htmlBody: response.replace(/\n/g, '<br>'),
      });
    }
  };

  return (
    <div className="response-card">
      <div className="response-header">
        <span className="response-label">Respuesta sugerida</span>
        <div className="response-actions">
          <button className="btn-icon" onClick={copyToClipboard} title="Copiar">
            {copied ? <Check size={14} /> : <Copy size={14} />}
          </button>
          <button className="btn-icon" onClick={onRegenerate} disabled={loading} title="Regenerar">
            <RefreshCw size={14} />
          </button>
          {onSaveAsTemplate && (
            <button className="btn-icon" onClick={() => onSaveAsTemplate(response)} title="Guardar como plantilla">
              <BookmarkPlus size={14} />
            </button>
          )}
        </div>
      </div>
      <div className="response-body">
        <pre>{response}</pre>
      </div>
      <button className="btn-primary btn-full" onClick={insertIntoReply}>
        <ArrowDownToLine size={14} />
        Insertar en respuesta
      </button>
    </div>
  );
}
